import React from 'react';
import { Button } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import Link from '@mui/material/Link';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import EventData from '../EventData';

const Title = styled('div')`
  font-size: 1.4rem;
  text-align: center;
  margin: 1rem 0;
`;

const SubTitle = styled('div')`
  font-size: 1.5rem;
`;

const Description = styled('div')`
  font-size: 1.1rem;
`;

const CarouselContainer = styled('div')`
  ${({ theme }) => `
    margin-top: 1rem;
    padding: 1rem 0;
    background: url(arrows.svg), linear-gradient(to right, #2196f3 , #0968b3);
    ${theme.breakpoints.down('md')} { padding: .5rem }
  `}
`;

const CarouselItem = styled('div')`
  ${({ theme }) => `
    display: grid;
    grid-template-columns: 60% auto;
    gap: 1rem;
    min-height: 22rem;
    padding: 1.5rem 1rem;
    ${theme.breakpoints.down('md')} { padding: .5rem }
  `}
`;

const TextPane = styled('div')`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    padding: 2.5rem;
    ${theme.breakpoints.down('md')} { padding: 0 }
  `}
`;

const VideoPane = styled('div')`
  display: flex;
  align-items: center;
  max-height: 100%;
  & img {
    aspect-ratio: 16 / 9;
    height: fit-content;
    max-width: 100%;
    max-height: 100%;
    border: 3px #ffffff solid;
  }
`;

const Badge = styled('div')`
  background: #ff0000;
  color: #ffffff;
  display: inline-block;
  margin-left: .8rem;
  transform: rotatez(45deg);
  width: 1.6rem;
  height: 1.6rem;

  &::before {
    content: '""';
    position: absolute;
    width: 1.6rem;
    height: 1.6rem;
    background: #ff0000;
    transform: rotatez(60deg);
  }
  &::after {
    content: "NEW";
    font-size: .6rem;
    text-align: center;
    line-height: 1.6rem;
    position: absolute;
    width: 1.6rem;
    height: 1.6rem;
    background: #ff0000;
    transform: rotatez(-60deg);
  }
`;

const CallToActionContainer = styled('div')`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & > * { width: fit-content }
`;

const CallToAction = ({ type, date, link }) => (
  <CallToActionContainer>
    { (type === 'future') && <em>{`Live @ ${dayjs(date).format('MMM DD, YYYY')}`}</em> }
    <Button
      component={Link}
      href={link}
      target="_blank"
      rel="noopener"
      variant="white"
    >
      { (type === 'future') ? 'Register Here' : 'Watch Recording' }
    </Button>
  </CallToActionContainer>
);

const Item = ({ item }) => (
  <CarouselItem>
    <TextPane>
      <SubTitle>
        {item.title}
        { (item.date > new Date()) && <Badge /> }
      </SubTitle>
      <Description>
        {item.description}
        <CallToAction {...item} />
      </Description>
    </TextPane>
    <VideoPane>
      <a href={item.link} target="_blank" rel="noopener">
        <img src={item.thumbnail} alt="Webinar" />
      </a>
    </VideoPane>
  </CarouselItem>
);

export default function HomePageSectionThree() {
  const items = EventData().getCarouselEvents();

  const carouselProps = {
    style: {
      height: '100%'
    },
    indicatorIconButtonProps: {
      style: { padding: '10px', color: '#008EFF' },
      'aria-label': 'Switch'
    },
    activeIndicatorIconButtonProps: {
      style: { color: '#ffffff' },
      'aria-label': 'Current'
    }
  };

  return (
    <CarouselContainer>
      <Title>
        Build-a-Bot Live Coding Series
      </Title>
      <Carousel {...carouselProps}>
        { items.map((item, i) => <Item key={i} item={item} />) }
      </Carousel>
    </CarouselContainer>
  );
}
